import { inject, Injectable } from '@angular/core';
import { I18nService } from '../../../core/services/i18n.service';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { ProductInterest } from '../../interfaces/lead-form/product-interest';

@Injectable({
  providedIn: 'root'
})
export class LeadFormProductToTableDataMapperService {

  i18n = inject(I18nService);

  constructor() { }

  public map(productInterest: ProductInterest): DialogTableDataRow[] {

    let paymentMethodsList: string = '';
    productInterest.paymentMethods.forEach(paymentMethod => {
      if (paymentMethodsList !== '') {
        paymentMethodsList += ', ';
      }
      paymentMethodsList += this.i18n.i18nLng()[paymentMethod];
    });

    return [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PAYMENTMETHODS',
        value: paymentMethodsList,
        valueWrap: true,
      },
    ];
  }

}
